import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types'; // ES6
import { Button, DatePicker } from 'antd';

import { MASCARA_DDMMYYYY, convertirTextAMomentLocal, esDeTipusMoment } from '../../commons/gestioDates';
import { obtenirAvisos } from '../../actions/avis';
import { crearNotificacioDatesObligatories, crearNotificacioSuperaPeriodeMaxim } from '../../commons/notificacio';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';

const MASCARA_HHmm = 'HH:mm';
const formatDataAMostrar = `${MASCARA_DDMMYYYY} ${MASCARA_HHmm}`;
const periode = 10;

class AvisSelectorPeriode extends Component {

    constructor(props) {
        super(props);

        //La propietat "dataActual" estará sempre informada, fins que no la tenim no es renderitza el component.
        const dataActualText = props.dataActual;
        const dataActual = dataActualText ? convertirTextAMomentLocal(dataActualText) : null;

        const dataIniciPerDefecte = (dataActual) ? dataActual.clone().startOf('day') : null;
        const dataFiPerDefecte = (dataActual) ? dataActual : null;

        this.state = {
            dataInici: dataIniciPerDefecte,
            dataFi: dataFiPerDefecte
        };

        this.esDiaDeshabilitat = this.esDiaDeshabilitat.bind(this);
        this.onSeleccionarPeriode = this.onSeleccionarPeriode.bind(this);
    }

    componentDidMount() {
        const dataInici = this.state.dataInici;
        const dataFi = this.state.dataFi;

        if (esDeTipusMoment(dataInici) && esDeTipusMoment(dataFi)) {
            this.props.obtenirAvisos(dataInici, dataFi);
        }
    }

    esDiaDeshabilitat(dataCalendari) {
        const dataActual = convertirTextAMomentLocal(this.props.dataActual);
        return dataCalendari ? dataCalendari.isAfter(dataActual, 'day') : false;
    }

    onSeleccionarPeriode() {
        const dataIniciText = this.state.dataInici;
        const dataFiText = this.state.dataFi;

        if (!dataIniciText || !dataFiText) {
            crearNotificacioDatesObligatories();
            return;
        }

        const dataInici = convertirTextAMomentLocal(dataIniciText);
        const dataFi = convertirTextAMomentLocal(dataFiText);

        if (!dataFi.isBetween(dataInici, dataInici.clone().add(periode, 'days'), 'minute', '[]')) {
            crearNotificacioSuperaPeriodeMaxim(periode);
            return;
        }

        this.props.obtenirAvisos(dataInici, dataFi);
    }

    render() {
        return (
            <div className='selector-periode'>
                <div className='selector-periode-dades'>
                    <div className='selector-periode-data'>
                        <label>Data inici:</label>
                        <DatePicker
                            value={ this.state.dataInici }
                            format={ formatDataAMostrar }
                            onChange={(data) => this.setState({ ...this.state, dataInici: data })}
                            disabledDate={ this.esDiaDeshabilitat }
                            showTime={{ format: MASCARA_HHmm }}
                            allowClear={ false }
                        />
                    </div>
                    <div className='selector-periode-data'>
                        <label>Data fi:</label>
                        <DatePicker
                            value={ this.state.dataFi }
                            format={ formatDataAMostrar }
                            onChange={(data) => this.setState({ ...this.state, dataFi: data })}
                            disabledDate={ this.esDiaDeshabilitat }
                            showTime={{ format: MASCARA_HHmm }}
                            allowClear={ false }
                        />
                    </div>
                    <Button
                        type='primary'
                        onClick={this.onSeleccionarPeriode}
                        className='selector-periode-boto'>
                        Seleccionar
                    </Button>
                </div>
            </div>
        );
    }
}

AvisSelectorPeriode.propTypes = {
    dataActual: PropTypes.string.isRequired,
    obtenirAvisos: PropTypes.func
};

const mapStateToProps = (state) => ({
    dataActual: state.dataActual
});

export default errorBoundaryWrapper(connect(mapStateToProps, { obtenirAvisos })(AvisSelectorPeriode));



// WEBPACK FOOTER //
// ./src/components/avis/avisSelectorPeriode.js